

import { useFrequency} from '../../../hooks'
import ProfessionalChartLoader from '../../../../../common/components/molecule/Chart/ChartLoaderView/ProfessionalChartLoader'
import ChartErrorView from '../../../../../common/components/molecule/Chart/ChartLoaderView/ChartErrorView'
import { createList } from '../../../../../common/utils/graph.utils'
import { formatDateByPeriod } from '../../../../../common/utils/dateFormatter'
import ChartLineView from '../../../../../common/components/molecule/Chart/ChartLineView/ChartLineView'


export default function FrequencyChartPresenter() {
    const { filter,  frequencyQuery:query}= useFrequency()


      
    if(query.isLoading) {
      return <ProfessionalChartLoader metricName="Fréquence" />
  }
  
  if(query.isError && query.error) {
    const error = query.error as Error

    return <ChartErrorView metricName="Fréquence" error={error} />
  }
  
  const dataChart = createList(filter.aggregateWindow || '1mo', filter, query.data)
    return (
      <ChartLineView
  
  
        xAxisData ={dataChart.listx.map((item) => formatDateByPeriod(item, filter.aggregateWindow || '1mo'))}
        data ={dataChart.listValue}
        label='Fréquence (Hz)'
        unit='Hz'
  
      />
    )
}